import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpServiceMdr } from "src/app/services/main.service";
import { HttpService } from "src/app/services/main_local.service";

@Component({
  selector: "app-add-user",
  templateUrl: "./add-user.component.html",
  styleUrls: ["./add-user.component.scss"],
})
export class AddUserComponent implements OnInit {
  organizationsList: any = [];
  rolesList = [
    {
      id: "224608005",
      value: "Front office staff",
    },
    {
      id: "224529009",
      value: "Device Issuer",
    },
    {
      id: "doctor",
      value: "Healthcare provider",
    },
    {
      id: "6868009",
      value: "Admin",
    },
    {
      id: "ict",
      value: "Analyst",
    },
  ];
  addPatientFormGroup!: FormGroup;
  authToken: any = null;
  mdrToken: any = null;
  type: any;
  userId = null;
  userDetail: any;
  userStatusText = "User account is active";
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<AddUserComponent>,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private httpFacadeService: HttpService,
    private httpFhirService: HttpServiceMdr,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.authToken = localStorage.getItem("mdr-token-auth");
    this.mdrToken = localStorage.getItem("mdr-token");
    this.type = data.type;
  }

  ngOnInit(): void {
    this.addPatientFormGroup = this._formBuilder.group({
      firstName: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern(/^[a-zA-Z]+$/)
        ],
      ],
      lastName: ["", [Validators.maxLength(50), Validators.pattern(/^[a-zA-Z]+$/)]],
      mobileNumber: [
        "",
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
          Validators.pattern(/^-?(0|[1-9]\d*)?$/)
        ],
      ],
      roleId: ["", [Validators.required]],
      orgId: ["", [Validators.required]],
      isActive: [true, [Validators.required]],
    });

    this.getOrganizationsList();
  }
  

  toggleChanged(event: any) {
    console.log(event);
    if (event.checked) this.userStatusText = "User account is active";
    else this.userStatusText = "User account is inactive";
  }
  getOrganizationsList() {
    this.httpFhirService
      .getRequestCall(
        "Organization?_count=50&_elements=_id,name&_sort=name",
        this.mdrToken,
        {}
      )
      .subscribe({
        next: (response) =>  {
          for (let org of response.entry) {
            let orgData = {
              id: org.resource.id,
              name: org.resource.name,
            };
            this.organizationsList.push(orgData);
          }
  
          if (this.data.type == "edit") {
            this.getUserDetail();
          }
        },
        error: (err) => {
          if(err.status == 401 || err.status == 403)
            this.dialogRef.close();
          this.errorStatus(err);
        }
      }
);
  }

  getUserDetail() {
    this.httpFhirService
      .getRequestCall(
        `Practitioner?_revinclude=PractitionerRole:practitioner&_id=${this.data.id}&_count=1&_sort=-_lastUpdated`,
        this.mdrToken,
        {}
      )
      .subscribe((userData) => {
        this.userDetail = userData;
        let orgId = this.organizationsList.find(
          (e: any) =>
            userData.entry[1].resource.organization.reference.split("/")[1] ==
            +e.id
        );
        console.log(
          "check org id: ",
          orgId,
          userData.entry[1].resource.organization.reference.split("/")[1],
          this.organizationsList
        );
        this.addPatientFormGroup.controls["firstName"].setValue(
          userData.entry[0].resource.name[0].given[0]
        );
        this.addPatientFormGroup.controls["lastName"].setValue(
          userData.entry[0].resource.name[0].family
        );
        this.addPatientFormGroup.controls["mobileNumber"].setValue(
          userData.entry[0].resource.telecom[0].value.split(" ")[1]
        );
        this.addPatientFormGroup.controls["roleId"].setValue(
          userData.entry[1].resource.code[0].coding[0].code
        );
        this.addPatientFormGroup.controls["orgId"].setValue(orgId.id);
        this.addPatientFormGroup.controls["isActive"].setValue(
          userData.entry[0].resource.active
        );
        this.userId = userData.entry[0].resource.id;
      });
  }

  updateData() {
    this.spinner.show();
    let userData = {
      resourceType: "Bundle",
      type: "transaction",
      entry: [
        {
          fullUrl: "Practitioner/" + this.userId,
          resource: {
            resourceType: "Practitioner",
            id: this.userId,
            active: this.addPatientFormGroup.controls["isActive"].value,
            name: [
              {
                family: this.addPatientFormGroup.controls["lastName"].value,
                given: [this.addPatientFormGroup.controls["firstName"].value],
              },
            ],
            telecom: [
              {
                system: "phone",
                value:
                  "(+678) " +
                  this.addPatientFormGroup.controls["mobileNumber"].value,
              },
            ],
          },
          request: {
            method: "PUT",
            url: "Practitioner/" + this.userDetail.entry[0].resource.id,
          },
        },
        {
          fullUrl: "PractitionerRole/" + this.userDetail.entry[1].resource.id,
          resource: {
            resourceType: "PractitionerRole",
            id: this.userDetail.entry[1].resource.id,
            practitioner: {
              reference: "Practitioner/" + this.userDetail.entry[0].resource.id,
            },
            organization: {
              reference:
                "Organization/" +
                this.addPatientFormGroup.controls["orgId"].value,
            },
            code: [
              {
                coding: [
                  {
                    system:
                      "http://terminology.hl7.org/CodeSystem/practitioner-role",
                    code: this.addPatientFormGroup.controls["roleId"].value,
                  },
                ],
              },
            ],
          },
          request: {
            method: "PUT",
            url: "PractitionerRole/" + this.userDetail.entry[1].resource.id,
          },
        },
      ],
    };

    let contactNumber = "(+678) " + this.addPatientFormGroup.controls["mobileNumber"].value;
    this.httpFhirService.getRequestCall(`Practitioner?_count=400&_total=accurate`, this.mdrToken, {} )
    .subscribe({
      next: (value: any) => {
        console.info(value)

        let userList =  value.entry.filter((e: any) => e.resource.id != this.userId && e.resource.telecom[0].value == contactNumber)
        if(userList.length == 0) {
        this.httpFhirService
        .postRequestCall(``, userData, this.mdrToken, {})
        .subscribe({
          next: (value) => {
            this.spinner.hide();
            this.snackBar.open("User updated", "", {
              horizontalPosition: "center",
              verticalPosition: "bottom",
              duration: 3 * 1000,
            });
            this.dialogRef.close({ data: "confirmed" });
          },
          error: (err) => {
            if(err.status == 401 || err.status == 403)
              this.dialogRef.close();
            this.errorStatus(err);
          },
        });
        }
        else {
          let err = {
            error: {
              message: "Duplicate mobile number"
            }
          }
          this.errorStatus(err);
        }
      }
    })
 
  }

  onSave() {
    this.spinner.show();
    if (this.data.type == "add") {
      let userData = {
        firstName: this.addPatientFormGroup.controls["firstName"].value,
        lastName: this.addPatientFormGroup.controls["lastName"].value,
        mobileNumber:
          "(+678) " + this.addPatientFormGroup.controls["mobileNumber"].value,
        role: [
          {
            roleId: this.addPatientFormGroup.controls["roleId"].value,
            orgId: this.addPatientFormGroup.controls["orgId"].value,
          },
        ],
        active: this.addPatientFormGroup.controls["isActive"].value,
      };

      this.httpFacadeService
        .postRequestCall("Practitioner", userData, this.authToken, {})
        .subscribe({
          next: (value) => {
            this.snackBar.open("User added", "", {
              horizontalPosition: "center",
              verticalPosition: "bottom",
              duration: 3 * 1000,
            });
            this.dialogRef.close({ data: "confirmed" });
            this.spinner.hide();
          },
          error: (err) => {
            if(err.status == 401 || err.status == 403)
            this.dialogRef.close();
            this.errorStatus(err);
          },
        });
    } else {
      this.updateData();
    }

  }

  onCancel() {
    this.dialogRef.close({ data: "cancelled" });
  }

  /**
   * Common Methods
   *
   */

  errorStatus(error: any) {
    console.log("error is: ", error)
    this.spinner.hide();
    this.snackBar.open(error.error.message, "", {
      horizontalPosition: "center",
      verticalPosition: "bottom",
      duration: 3 * 1000,
    });
  }

  keyPressChar(event:any) {
    let inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  capitalizeFirstLetter(controlName: any) {

    let value = this.addPatientFormGroup.controls[controlName].value;
    let updatedValue = value.charAt(0).toUpperCase() + value.slice(1);
    this.addPatientFormGroup.controls[controlName].setValue(updatedValue)
  }

  keyPressNumber(event:any) {
    let test = String.fromCharCode(event.keyCode);
    if (/\d/.test(test)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

}

